import React, { useState } from 'react';
import { SPECIALTY_FLU_VACCINATIONS } from '../../../bookings/constants';
import { Popover } from '../../../common/components/Popover/Popover';
import { CountryState } from '../../../common/components/SearchHeader/constants';
import { makeSearchUrl } from '../../../common/components/SearchHeader/urls/makeSearchUrl';
import { useRouter } from '../../../common/hooks/useRouter';
import { SuburbPredictionType } from '../../../patient-forms/PatientForm/AutoCompleteFields/AutoComplete/PredictionType';
import {
  CTAContainer,
  BookNowButton,
  BookNowButtonFooter,
  StyledAutoCompleteSuburbField,
} from './FluvaxCTA.styles';

type CTALocationType = 'HEADER' | 'SUB_HEADER' | 'FOOTER';

interface TrackingAttributes {
  'data-cta': string;
  'data-event': string;
  'data-testid': string;
}

interface FluvaxCTAProps {
  trackingAttributes?: TrackingAttributes;
  CTALocation?: CTALocationType;
}

const disabledReason = 'Please enter your suburb or postcode to continue.';

export const FluvaxCTA = ({ trackingAttributes, CTALocation }: FluvaxCTAProps) => {
  const router = useRouter();

  const [suburbName, setSuburbName] = useState<string>();
  const [stateName, setStateName] = useState<string>();
  const [postcode, setPostcode] = useState<string>();

  const onSelectSuburb = (suburb: SuburbPredictionType) => {
    setPostcode(suburb?.data.postcode);
    setStateName(suburb?.data.state);
  };

  const onValueClear = () => {
    setSuburbName('');
  };

  const stringToCountryState = (input: string | undefined) => {
    if (!input) return undefined;

    if (Object.keys(CountryState).includes(input)) {
      return Object.values(CountryState)[Object.keys(CountryState).indexOf(input)];
    }

    return undefined;
  };

  const tooltipDisabled = !!(stateName && suburbName && postcode);

  const bookNowHandler = () => {
    const searchURL = makeSearchUrl({
      onlineAppointments: {},
      location: { suburb: { name: suburbName, state: stringToCountryState(stateName), postcode } },
      topic: {
        specialist: SPECIALTY_FLU_VACCINATIONS,
      },
      alwaysShowFilters: true,
    });

    void router?.push(searchURL);
  };

  return (
    <CTAContainer>
      <StyledAutoCompleteSuburbField
        labelKey="Search Suburb or Postcode"
        autoComplete="off"
        state={[suburbName, setSuburbName]}
        onSelectPrediction={onSelectSuburb}
        onClear={onValueClear}
      />
      <Popover content={disabledReason} disabled={tooltipDisabled}>
        {CTALocation === 'FOOTER' ? (
          <BookNowButtonFooter
            {...trackingAttributes}
            disabled={!stateName || !suburbName || !postcode}
            onClick={bookNowHandler}
          >
            Find nearby appointments
          </BookNowButtonFooter>
        ) : (
          <BookNowButton
            {...trackingAttributes}
            disabled={!stateName || !suburbName || !postcode}
            onClick={bookNowHandler}
          >
            Find nearby appointments
          </BookNowButton>
        )}
      </Popover>
    </CTAContainer>
  );
};
